module.exports = __webpack_public_path__ + "media/images/svg/person-2faed03603bf433f54c11f66c726b72d.svg";